module.exports = __webpack_public_path__ + "img/company_email-17.d959589b.svg";